import React, { lazy, useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,   FirstAds,MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
import bodyMeasureOutline from "../../../images/body-measure.webp";
const TITLE = "Calculatrice de détermination du type de corps - Connaissez votre forme";
const DESCRIPTION =
  "Calculatrice de détermination du type de corps - Connaissez votre forme en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "de détermination du type de corps connaissez votre forme, calculatrice de détermination du type de corps connaissez votre forme, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/body-type-calculator/";
function BodyTypeCalculator() {
  const [bust, setBust] = useState("");
  const [waist, setWaist] = useState("");
  const [highHip, setHighHip] = useState("");
  const [hip, setHip] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [whr, setWHR] = useState(null);
  const handleBustChange = (event) => {
    setBust(event.target.value);
  };
  const handleWaistChange = (event) => {
    setWaist(event.target.value);
  };
  const handleHighHipChange = (event) => {
    setHighHip(event.target.value);
  };
  const handleHipChange = (event) => {
    setHip(event.target.value);
  };
  const calculateBodyType = () => {
    const bustNum = parseFloat(bust);
    const waistNum = parseFloat(waist);
    const highHipNum = parseFloat(highHip);
    const hipNum = parseFloat(hip);
    if (
      isNaN(bustNum) ||
      isNaN(waistNum) ||
      isNaN(highHipNum) ||
      isNaN(hipNum) ||
      bustNum <= 0 ||
      waistNum <= 0 ||
      highHipNum <= 0 ||
      hipNum <= 0
    ) {
      setError("Veuillez saisir des valeurs valides");
      setResult(null);
      setWHR(null);
      return;
    }
    let bodyType = "Inconnu";
    const whrValue = (waistNum / hipNum).toFixed(2);
    if (bustNum === hipNum && waistNum < bustNum) {
      bodyType = "Sablier";
    } else if (hipNum > bustNum && waistNum < hipNum) {
      bodyType = "Poire";
    } else if (bustNum > hipNum && waistNum < bustNum) {
      bodyType = "Triangle inversé";
    } else if (bustNum === waistNum && waistNum === hipNum) {
      bodyType = "Rectangle";
    } else if (waistNum >= bustNum && waistNum >= hipNum) {
      bodyType = "Pomme";
    }
    setResult(bodyType);
    setWHR(whrValue);
    setError(null);
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-sm-12 col-md-9">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-7">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice de type de corps vous aide à déterminer votre type de corps en fonction
                  des mesures de la poitrine, de la taille, des hanches et des cuisses. Grâce à cette
                  calculatrice, vous pouvez avoir une compréhension précise de la forme de votre corps,
                  ce qui vous aide à choisir des vêtements qui vous conviennent parfaitement. Connaître
                  votre type de corps contribue non seulement à améliorer votre apparence, mais augmente
                  également votre confiance en vous et votre confort au quotidien. En utilisant la
                  calculatrice, vous pouvez identifier les zones que vous souhaitez mettre en évidence
                  et celles que vous souhaitez minimiser, ce qui contribue au choix de vêtements qui
                  améliorent votre apparence générale et correspondent à votre style personnel. Que vous
                  souhaitiez mettre en valeur votre beauté naturelle ou atteindre un équilibre entre
                  les différents détails de votre corps, cette calculatrice est l'outil idéal pour
                  y parvenir.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-8 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Calculatrice de type de corps
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="bust" className="form-label ms-2">
                      Mesure de la poitrine
                    </label>
                  </b>
                  <input
                    type="number"
                    id="bust"
                    value={bust}
                    onChange={handleBustChange}
                    className="form-control ml-2"
                    style={{ width: "120px" }}
                    placeholder="80"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">cm</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="waist" className="form-label ms-2">
                      Mesure de la taille
                    </label>
                  </b>
                  <input
                    type="number"
                    id="waist"
                    value={waist}
                    onChange={handleWaistChange}
                    className="form-control ml-2"
                    style={{ width: "120px" }}
                    placeholder="70"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">cm</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="highHip" className="form-label ms-2">
                      Mesure des cuisses
                    </label>
                  </b>
                  <input
                    type="number"
                    id="highHip"
                    value={highHip}
                    onChange={handleHighHipChange}
                    className="form-control ml-2"
                    style={{ width: "120px" }}
                    placeholder="90"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">cm</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="hip" className="form-label ms-2">
                      Mesure des hanches
                    </label>
                  </b>
                  <input
                    type="number"
                    id="hip"
                    value={hip}
                    onChange={handleHipChange}
                    className="form-control ml-2"
                    style={{ width: "120px" }}
                    placeholder="95"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">cm</span>
                  </div>
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateBodyType}
                  >
                    Calculer                  </button>
                </div>
              </div>
              <div className="col-sm-12 col-md-4">
                <img
                  loading="lazy"
                  src={bodyMeasureOutline}
                  alt="Illustration des mesures"
                  style={{ width: "100%", paddingTop: "100px", height: "60%" }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div>
                  {error && (
                    <div
                      style={{
                        backgroundColor: "#f8d7da",
                        borderColor: "#f5c6cb",
                        color: "#721c24",
                        padding: "15px",
                        marginBottom: "20px",
                        borderRadius: "4px",
                      }}
                    >
                      <b>
                        <u>Erreur:</u>
                      </b>{" "}
                      {error}
                    </div>
                  )}
                  { result && (
                    <div
                      style={{
                        backgroundColor: "#D1E7DD",
                        borderColor: "#c3e6cb",
                        color: "#155724",
                        padding: "15px",
                        marginBottom: "20px",
                        borderRadius: "4px",
                      }}
                    >
                      <h4>Résultat:</h4>
                      <p
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        Votre type de corps: {result}
                      </p>
                      <p>Rapport taille-hanche (RCH): {whr}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
  <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Les types de morphologie</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Adapter son entranement</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BodyTypeCalculator;
